import { getInitEvent } from './helpers';
import { dataLayerPush } from '../../helpers';

export const coreReady = ({ device, metaEventId, store = {} } = {}) => {
  const { components = {} } = store;
  const dataLayer = getInitEvent({
    ...device,
    metaEventId,
    step: components['finder'] ? 'BOOKINGENTRANCE' : 'NAVIGATION',
    ...store,
  });
  dataLayerPush(dataLayer);

  return dataLayer;
};
